import React, { useState } from "react"
// import DescriptionDetail from "src/shared/components/data-display/description-detail/DescriptionDetail"

import "./Resumen.css"
// import DetailBold from "./sections/DetailBold"
// import Detail from "./sections/Detail"
// import { PrimaryButton } from "src/pages/home/room-detail/sections/elements/Elements"
import { useNavigate } from "react-router-dom"
// import { formatCurrency } from "src/shared/hooks/formatCurrency"
// import { ModalConfirm } from "src/shared/components/layout"
// import Icon from "src/shared/icons"
import { Habitacion, TipoDescuento, TiposAlojamientos } from "src/gql/schema"
// import IconBorder from "src/shared/components/data-display/IconBorder/IconBorder"
import useSnackbar from "src/shared/hooks/useSnackbar"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import ResumenInstance from "src/shared/components/data-display/Resumen/Resumen"
import ResumenTitle from "src/shared/components/data-display/Resumen/ResumenTitle/ResumenTitle"
import ResumenContent from "src/shared/components/data-display/Resumen/ResumenContent/ResumenContent"
import ResumenSection from "src/shared/components/data-display/Resumen/ResumenSection/ResumenSection"
import Detail from "src/shared/components/data-display/Detail/Detail"
import DetailIcon from "src/shared/components/data-display/Detail/kit/DetailIcon/DetailIcon"
import DetailContent from "src/shared/components/data-display/Detail/kit/DetailContent/DetailContent"
import DetailRow from "src/shared/components/data-display/Detail/kit/DetailRow/DetailRow"
import DetailText from "src/shared/components/data-display/Detail/kit/DetailText/DetailText"
import DetailEstancia from "./sections/DetailEstancia/DetailEstancia"
import DetailsExtras from "./sections/DetailsExtras/DetailsExtras"
import DetailsTotales from "./sections/DetailsTotales/DetailsTotales"
import ResumenFooter from "src/shared/components/data-display/Resumen/ResumenFooter/ResumenFooter"
import { ModalConfirm } from "src/shared/components/layout"
import IconBorder from "src/shared/components/data-display/IconBorder/IconBorder"
import Icon from "src/shared/icons"
import { formatCurrencyToFixed } from "src/shared/hooks/formatCurrency"
import { div, sum, times } from "src/shared/helpers/calculator"

const Resumen = ({
    habitacion,
    roomDays = 1,
    roomSerice,
    impuestoRoomService,
    numOrdenesRoomService,
    totalEstancia,
    tipoAlojamiento,
    totalImpuestos,
    totalPagado,
    pagosPendientes,
    hospedajesExtra,
    personasExtra,
    montoPersonasExtra,
    habitacion_id,
    totalCheckInAnticipado,
    propina,
    montoTotalHospedajesExtra,
    montoTotalBebidas,
    montoTotalAlimentos,
    montoTotalSexAndSpa,
}: {
    habitacion?: Habitacion
    roomDays: number
    numOrdenesRoomService: number
    tipoAlojamiento: TiposAlojamientos
    roomSerice: number
    impuestoRoomService: number
    totalEstancia: number
    totalImpuestos: number
    totalPagado: number
    pagosPendientes?: number
    habitacion_id: string
    hospedajesExtra?: number
    montoTotalHospedajesExtra?: number
    totalCheckInAnticipado?: number
    propina: number
    montoTotalBebidas: number
    montoTotalAlimentos: number
    montoTotalSexAndSpa: number
    personasExtra: number
    montoPersonasExtra: number
}) => {
    const navigate = useNavigate()

    const [isModalPagosPendientesOpen, setIsModalPagosPendientesOpen] = useState(false)
    const { showSnackbar } = useSnackbar()
    const { formatCustomDate } = useFormatDate()

    const extrasConDescuento = (habitacion?.ultima_renta?.extras || []).filter((e) => e.descuento_aplicado)
    const extrasDescuentosGroups = new Map<string, typeof extrasConDescuento>()
    extrasConDescuento.forEach((extra) => {
        const key = extra.venta_id ?? `no_venta_${extra.extra_id}`
        if (!extrasDescuentosGroups.has(key)) extrasDescuentosGroups.set(key, [])
        extrasDescuentosGroups.get(key)!.push(extra)
    })
    const extrasDescuentosAgrupados = Array.from(extrasDescuentosGroups.values()).map((group) => {
        const desc = group[0].descuento_aplicado!
        const monto = desc.data_descuento.tipo_descuento === TipoDescuento.Porcentaje
            ? div(times(sum(group.map((e) => e.monto_extra || 0)), desc.data_descuento.valor), 100)
            : desc.data_descuento.monto_calculado
        return {
            nombre: desc.descuento?.nombre || "",
            monto,
            tipo_descuento: desc.data_descuento.tipo_descuento,
            valor: desc.data_descuento.valor,
        }
    })
    // TODO: 1 no cuadra la sumatoria del total en venta tipo motel entre front y back
    return (
        <ResumenInstance style={{width: "fit-content", minWidth: "300px"}}>
            <ResumenContent>
                <ResumenSection>
                    <ResumenTitle>Resumen</ResumenTitle>
                    {!!habitacion?.ultima_renta?.nombre_huesped && (
                        <Detail color='var(--tipografa)'>
                            <DetailIcon name='userFilled' />
                            <DetailContent>
                                <DetailRow>
                                    <DetailText type='normal'>
                                        Nombre completo
                                    </DetailText>
                                </DetailRow>
                                <DetailRow>
                                    <DetailText type='bold'>
                                        {habitacion?.ultima_renta?.nombre_huesped || "-"}
                                    </DetailText>
                                </DetailRow>
                            </DetailContent>
                        </Detail>
                    )}
                    <Detail color='var(--tipografa)'>
                        <DetailIcon name='UserThinFilled' />
                        <DetailContent>
                            <DetailRow>
                                <DetailText type='normal'>
                                    Total de personas
                                </DetailText>
                            </DetailRow>
                            <DetailRow>
                                <DetailText type='bold'>
                                    {(habitacion?.ultima_renta?.numero_personas || 0) +
                                        (habitacion?.ultima_renta?.personas_extra || 0) +
                                        ""}
                                </DetailText>
                            </DetailRow>
                        </DetailContent>
                    </Detail>
                    {!!habitacion?.ultima_renta?.reserva?.origen && (
                        <Detail color='var(--tipografa)'>
                            <DetailIcon name='BusinessGlobalFill' />
                            <DetailContent>
                                <DetailRow>
                                    <DetailText type='normal'>
                                        Origen de la reserva
                                    </DetailText>
                                </DetailRow>
                                <DetailRow>
                                    <DetailText type='bold'>
                                        {habitacion?.ultima_renta?.reserva?.origen || "-"}
                                    </DetailText>
                                </DetailRow>
                            </DetailContent>
                        </Detail>
                    )}
                    <Detail color='var(--tipografa)'>
                        <DetailIcon name='calendarFill' />
                        <DetailContent>
                            <DetailRow>
                                <DetailText type='normal'>
                                    Fecha de estancia
                                </DetailText>
                            </DetailRow>
                            <DetailRow>
                                <DetailText type='bold'>
                                    {habitacion?.ultima_renta?.fecha_registro
                                        ? `${formatCustomDate(
                                            habitacion?.ultima_renta?.fecha_registro,
                                            "MMM, DD YYYY"
                                        )} - ${formatCustomDate(habitacion?.ultima_renta?.fecha_condensada, "MMM, DD YYYY")}`
                                        : "-"}
                                </DetailText>
                            </DetailRow>
                        </DetailContent>
                    </Detail>
                    {numOrdenesRoomService > 0 && (
                        <Detail color='var(--tipografa)'>
                            <DetailIcon name='roomServiceCommand' />
                            <DetailContent>
                                <DetailRow>
                                    <DetailText type='normal'>
                                        Órdenes de room service
                                    </DetailText>
                                </DetailRow>
                                <DetailRow>
                                    <DetailText type='bold'>
                                        {String(numOrdenesRoomService) || "0"}
                                    </DetailText>
                                </DetailRow>
                            </DetailContent>
                        </Detail>
                    )}
                    <DetailEstancia rentas_tarifas={habitacion?.ultima_renta?.rentas_tarifas || []} />
                    <DetailsExtras
                        extras={[...(habitacion?.ultima_renta?.extras || []), ...(habitacion?.ultima_renta?.reserva?.extras || [])]}
                        tipoAlojamiento={tipoAlojamiento}
                        reservas_tarifas={habitacion?.ultima_renta?.reserva?.reservas_tarifas || []}
                    />
                </ResumenSection>

                <DetailsTotales
                    totalEstancia={totalEstancia || 0}
                    estanciasExtra={hospedajesExtra || 0}
                    totalEstanciaExtra={montoTotalHospedajesExtra || 0}
                    roomDays={roomDays}
                    tipoAlojamiento={tipoAlojamiento}
                    horasEstancia={habitacion?.ultima_renta?.rentas_tarifas?.[0]?.tarifa?.grupo_tarifa?.duracion ?? undefined}
                    totalCheckInAnticipado={totalCheckInAnticipado}
                    personasExtra={personasExtra}
                    montoPersonasExtra={montoPersonasExtra}
                    roomSerice={roomSerice}
                    numOrdenesRoomService={numOrdenesRoomService}
                    totalImpuestos={totalImpuestos}
                    totalPagado={totalPagado}
                    pagosPendientes={pagosPendientes}
                    descuentos={[
                        ...(habitacion?.ultima_renta?.descuento_aplicado
                            ? [{
                                nombre: habitacion.ultima_renta.descuento_aplicado.descuento?.nombre || "",
                                monto: habitacion.ultima_renta.descuento_aplicado.data_descuento.monto_calculado,
                                tipo_descuento: habitacion.ultima_renta.descuento_aplicado.data_descuento.tipo_descuento,
                                valor: habitacion.ultima_renta.descuento_aplicado.data_descuento.valor,
                            }]
                            : []),
                        ...extrasDescuentosAgrupados,
                    ]}
                />
            </ResumenContent>
            <ResumenFooter buttonText="Confirmar check out" onClick={() => {
                if ((pagosPendientes || 0) > 0) {
                    setIsModalPagosPendientesOpen(true)
                    return
                }
                showSnackbar({
                    title: "Checkout completado",
                    status: "success",
                    text: `La habitación **${habitacion?.tipo_habitacion?.nombre} ${habitacion?.numero_habitacion}** ha sido liberada por los huéspedes`,
                })
                navigate(`/u/detalle-habitacion/end-checkout/${habitacion_id}`, {
                    state: {
                        montoTotalBebidas,
                        montoTotalAlimentos,
                        montoTotalSexAndSpa,
                    },
                })
            }} />

            <ModalConfirm
                icon={
                    <IconBorder primaryBgDiameter={24} primaryBgColor="var(--green-available)">
                        <Icon name="building4Fill" color="var(--white)" height={14} width={14} />
                    </IconBorder>
                }
                iconTheme="success"
                title="Pagos pendientes"
                confirmLabel="Ver pendientes"
                isOpen={isModalPagosPendientesOpen}
                description={
                    <>
                        <p className="room-detail__page--modal--confirm">
                            La habitación{" "}
                            <span className="room-detail__page--modal--confirm--bold">
                                {habitacion?.tipo_habitacion?.nombre} {habitacion?.numero_habitacion}
                            </span>{" "}
                            tiene pagos pendientes por un total de{" "}
                            <span className="room-detail__page--modal--confirm--bold">
                                {formatCurrencyToFixed(pagosPendientes || 0)}
                            </span>
                        </p>
                    </>
                }
                onCloseDialog={({ confirmed }) => {
                    setIsModalPagosPendientesOpen(false)
                    if (!confirmed) {
                        return
                    }
                    navigate(`/u/detalle-habitacion/pending-payments/${habitacion_id}`)
                }}
            />

        </ResumenInstance>
    )
}

export default Resumen
